export default "__VITE_ASSET__Cfg8FhRY__"